import { computed, Ref } from 'vue'
import { LoanColumn } from '@/modules/LoanManager/constants/loan-manager-columns'

export type SortDirection = 'asc' | 'desc'

export type ManagerColumn = LoanColumn // | AgentColumn | CustomerColumn...

export type SortOptions = {
  sortBy: string
  sortDirection: SortDirection
}

export default function useColumnSort(
  initialSortOptions: Ref<SortOptions | null>,
  emit: (event: 'onSort', sortOptions: SortOptions | null) => void,
) {
  const sortBy = computed(() =>
    initialSortOptions.value ? initialSortOptions.value.sortBy : null,
  )
  const sortDirection = computed(() =>
    initialSortOptions.value ? initialSortOptions.value.sortDirection : null,
  )

  function changeSort(column: string | null) {
    if (!column) {
      emit('onSort', null)
      return
    }

    let newSortDirection =
      sortDirection.value === null
        ? 'asc'
        : sortDirection.value === 'asc'
        ? 'desc'
        : null

    if (column !== sortBy.value) {
      newSortDirection = 'asc'
    }

    // TODO: should reset to defaults when all columns are default
    if (newSortDirection === null) {
      emit('onSort', null)
      return
    }

    const sortOptions = {
      sortBy: column,
      sortDirection: newSortDirection,
    } as SortOptions

    emit('onSort', sortOptions)
  }

  function getColumnIcon(columnName: string) {
    if (columnName !== sortBy.value) {
      return 'sort'
    }

    return sortDirection.value === 'asc'
      ? 'chevron-up'
      : sortDirection.value === 'desc'
      ? 'chevron-down'
      : 'sort'
  }

  return {
    changeSort,
    getColumnIcon,
  }
}
